import React, { Component }           from 'react';
import {connect}                      from 'react-redux';
import { Field, reduxForm }           from 'redux-form';
import moment                         from 'moment';
import renderFieldSelect              from '../../../container/renderFieldSelect';
import renderFieldTextArea            from '../../../container/renderFieldTextArea';
import FlashRetornoNulo               from '../../../container/FlashRetornoNulo';
import { SetNotaTarefasTurmasAlunos } from '../../../actions/tarefaAction';
import { SetError }                   from '../../../actions/notificacaoAction';

class Missao_Resposta_list extends Component {

    constructor(props){

        super(props);
        this.state = {
            listNotaAlunos : [],
            feedBackAlunos : [],
            listIdAlunos   : [],
            disabled       : true,
            disabled2      : false,
            disabled3      : false,
            redirect       : false,
            valMax         : 80,
            countDinamic   : 400
        }
    }

    renderListAlunos(){

        const listAlunos = this.props.alunos.filter(elem => (this.props.status? elem.ent_tar_pontuacao !=null : elem.ent_tar_pontuacao === null));
        
        const altura     = {"marginBottom" : "10px"}
        const fontSize   = {"fontSize" : "13px"}

        if(listAlunos.length>0) {

               return listAlunos.map((elem,i)=>{
                   return <div className="panel panel-default" key={i} style={altura}>
                                <div className="panel-heading">
                                    <div className="media">
                                        <div className="media-left">
                                            <a href={void (0)}>
                                                <img width="35" className="media-object img-circle" src={elem.use_foto} data-holder-rendered="true" alt="Img" />
                                            </a>
                                        </div>
                                        <div className="media-body">
                                            <h4 className="pull-left">{elem.use_nome}</h4>
                                            {elem.ent_tar_pontuacao != null ? <h4 style={fontSize} className="pull-right label label-success">Avaliado</h4> : <h4 style={fontSize} className="pull-right label label-primary">Não avaliado</h4>}
                                        </div>
                                    </div>
                                </div>
                                <div className="panel-body">
                                    <div className='row'>
                                        <div className="col-md-6">
                                            <p>Documento : {elem.ent_tar_anexo ? <a href={elem.ent_tar_anexo} target='_blank'>Visualizar documento</a> : "Não enviado"}</p>
                                            <p>Data : {elem.ent_tar_data_resposta ? moment(elem.ent_tar_data_resposta).format("DD/MM/YYYY") : "---"}</p>
                                            <p>Nota : {elem.ent_tar_pontuacao != null ? elem.ent_tar_pontuacao : "--"}</p>
                                            <p>Feedback : {elem.ent_tar_feedback ? elem.ent_tar_feedback : "--"}</p>
                                        </div>
                                        <div className="col-md-6">
                                            {this.feedbackButton(elem)}
                                        </div>
                                    </div>
                                </div>
                            </div>;});

        } else {

              return <FlashRetornoNulo/>;
        }

    }

    feedbackButton(elem){
        
        const {handleSubmit}  = this.props;
        const listaNotas      = [0,1,2,3,4,5,6,7,8,9,10];
        const countCaract     = this.state.countDinamic;
        const notasChange     = this.state[`nota_${elem.use_id}`];
        const feedChange      = this.state[`feedback_${elem.use_id}`];
        const textoButton     = (elem.ent_tar_pontuacao == null ? 'Enviar avaliação': 'Editar avaliação');
        const usu_criador = this.props.pro_criador;

        if ((feedChange !== undefined || feedChange<countCaract) && (notasChange !== undefined || notasChange>0)){     
            this.state.disabled = false;
         }else{
            this.state.disabled = true;
         }
         
         if (feedChange === countCaract || notasChange === ""){ 
            this.state.disabled = true;     
         }

         if (feedChange<0){ 
            this.state.disabled = true;
            this.state[`valid_${elem.use_id}`] = true;     
         }else{
            this.state[`valid_${elem.use_id}`] = false;
         }

         if (this.props.session.id !=usu_criador) {
            this.state.disabled = true;  
            this.state.disabled3 = true;  
         }

      return  <form onSubmit={handleSubmit(this.handleSubmit.bind(this,elem.use_id))} >
                <div className="form-group">
                    <Field
                        name      = {`nota_${elem.use_id}`}
                        somefield = {`nota_${elem.use_id}`}
                        component = {renderFieldSelect}
                        habilitar = {this.state.disabled3}
                        onChange  = {e => this.setState({[`nota_${elem.use_id}`] : e.target.value })}
                        option    = {listaNotas.map((elem, ar) => { return <option key={ar} value={elem}>{elem}</option>;})}
                    />
                </div>
                <div className="form-group">
                <span className={`count pull-right ${this.state[`valid_${elem.use_id}`] && 'count-valid'}`}>{this.state[`feedback_${elem.use_id}`] !== undefined ? this.state[`feedback_${elem.use_id}`]:countCaract}</span>
                    <Field
                        name      = {`feedback_${elem.use_id}`}
                        component = {renderFieldTextArea}
                        habilitar = {this.state.disabled3}
                        value     = { this.state.feedback_usuario }
                        onChange  = {e => this.setState({feedback_usuario: e.target.value,
                                                         [`feedback_${elem.use_id}`] : countCaract - e.target.value.length })}
                    />
                </div>

                {this.state.disabled3 ? <h4 className="pull-right label label-danger">Esta missão só pode ser avaliada pelo professor a criou.</h4>: 
                !this.state.disabled ? 
                    <button type="submit" className="btn btn-primary btn-sm pull-right">{textoButton}</button>:  
                    <a href={void(0)} disabled={this.state.disabled} className="btn btn-default btn-sm pull-right">{textoButton}</a>
               
                }              
            </form>;
    }

    handleSubmit(e){

          const nota     = document.getElementsByName(`nota_${e}`)[0].value;
          const feedback = document.getElementsByName(`feedback_${e}`)[0].value;
          const use_id   = e;

            let dados  = {
                ent_tar_cod_aluno  : use_id,
                ent_tar_pontuacao  : nota,
                ent_tar_feedback   : feedback,
                ent_tar_cod_tarefa : this.props.tar_id,
                cur_id             : this.props.cur_id
            }

           this.props.SetNotaTarefasTurmasAlunos(dados).then((response) =>{
               alert("Ação realizada com sucesso!");
               // this.setState({redirect:true})
            }).catch((error) =>{
                this.props.SetError(500);
              });
    }

    countCaractere(e){
        const text_remaning = this.state.valMax - e.target.textLength;
        this.setState({countDinamic:text_remaning})
    }

    render() {

        return (
                 <div className="panel panel-azul-claro panel-cinza">
                    <div className="panel-body">
                      {this.renderListAlunos()}
                    </div>
                </div>
               )
    }
}

function mapStateToProps(state){

    return {
            alunos : state.tarefaReducer.all_componentes_tarefa,
            session      : state.auth.session,
            statusMissao : state.tarefaReducer.statusMissao,
            pro_criador : state.tarefaReducer.pro_criador,
            nome_turma : state.tarefaReducer.nome_turma,
            menu   : state.configReducer.menu
        }
}

export default reduxForm({
  form : 'tarefa_desempenho'
})(connect(mapStateToProps, { SetNotaTarefasTurmasAlunos,SetError})(Missao_Resposta_list));






// WEBPACK FOOTER //
// ./src/components/professor/missoes/missao_resposta_list.js